<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formStore">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>
          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar Bodega'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>

            <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'" [variant]="undefined"
              [width]="'5.5rem'" [icon]="'pi pi-plus'" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="storeContract.userNameCreate"
              [createDate]="storeContract.createDate" [userNameUpdate]="storeContract.userNameUpdate"
              [updateDate]="storeContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col-lg-2 col-md-3 col-sm-4 col-12">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-12">
              <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
                (onChangeNumber)="changeCode($event)"></app-custom-input-number>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-12">
              <app-custom-input-text formControlName="alterCode" [labelText]="'Cód. Alterno'"
                [maxLength]="20"></app-custom-input-text>
            </div>
            <div class="col-lg-3 col-md-5 col-sm-4 col-12">
              <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [required]="true"
                [maxLength]="50"></app-custom-input-text>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-12">
              <app-custom-select formControlName="inventoryId" [labelText]="'Inventario'" [list]="listInventories"
                [required]="true">
              </app-custom-select>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-12">
              <app-custom-input-text formControlName="costCenterCode" [labelText]="'C.Costos'"
                [maxLength]="10"></app-custom-input-text>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-10">
              <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateStore">
              </app-custom-tag>
            </div>
            <div class="col field-button">
              <app-custom-button [title]="titleState" [icon]="'pi pi-undo'" [severity]="'primary'"
                (onClick)="changeStateStore()">
              </app-custom-button>
            </div>
            <div class="field-checkbox">
              <app-custom-checkbox formControlName="ownStore" [labelText]="'Propia'"></app-custom-checkbox>
            </div>
            <div class="field-checkbox-occupancyPercentageReport">
              <app-custom-checkbox formControlName="occupancyPercentageReport"
                [labelText]="'% Ocupación'"></app-custom-checkbox>
            </div>
            <div class="field-checkbox">
              <app-custom-checkbox formControlName="swMandate" [labelText]="'Mandato'"></app-custom-checkbox>
            </div>
            <div class="col-lg-1 col-md-1 col-1 d-flex align-items-end mt-1">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>